import React from 'react';
import { apiGetSingleSecretary, apiChangeStatus } from '../../../lib/apiUsers';
import { withRouter, Link } from 'react-router-dom';
import ModalDesactivar from '../modalDesactivar';

const DetailsApuntador = (props) => {

    const { id } = props.match.params;
    const { NotificationManager } = props;

    const [secretary, setSecretary] = React.useState({ name: '', username: '', last_sync: '', device_id: '' });
    const [modalDesactivar, setModalDesactivar] = React.useState({
        show: false,
        name: secretary.name,
        activate: true,
        type: 'desactivar',
        typeUser: 'secretario',
        id: secretary.id
    });

    React.useEffect(() => {
        apiGetSingleSecretary(id)
            .then(response => {
                if (response.error) {

                }
                else {
                    setSecretary(response);
                    setModalDesactivar({
                        show: false,
                        name: response.name,
                        typeUser: 'secretario',
                        id: response.id
                    });
                }
            })
    }, [id])

    const handleClose = () => {
        setModalDesactivar({ ...modalDesactivar, show: false });
    }

    const ConfirmModalActivate = () => {
        apiChangeStatus(modalDesactivar.id)
            .then(response => {
                if (response.error) {
                    console.log("paso un error al desactivar");
                    NotificationManager.error("algo salio mal", '', 4000);
                } else {
                    setSecretary({ ...secretary, active: !secretary.active });

                    NotificationManager.success("Se ha cambiado el status del usuario exitósamente", '', 4000);
                }
            })
    }

    const ShowModal = () => {
        setModalDesactivar({
            ...modalDesactivar,
            type: !secretary.active ? 'activar' : 'desactivar',
            show: true,
        });
    }

    return (<div className="">
        <div className="row ">
            <div className="col-md-6 col-12">
                <h5><i className="fas fa-arrow-left" onClick={() => props.history.goBack()} /> Detalles de secretario</h5>
            </div>

            <div className="col-md-6 col-12 tar">
                {
                    secretary.active ?
                        <button className="btn btn-lgt btn-danger" onClick={ShowModal}><i className="fas fa-ban" /> Desactivar</button>
                        :
                        <button className="btn btn-lgt btn-info" onClick={ShowModal}><i className="fas fa-ban" /> Activar</button>
                }
                <Link to={"/usuarios/editar/secretario/" + id} className="btn btn-lgt btn-success"><i className="fas fa-edit" /> Editar</Link>
            </div>

        </div>
        <div className="card separate">
            <div className="card-body">
                <h4>Información secretario</h4>
                <hr />
                <div className="row">
                    <div className="col-md-4 col-12">
                        <p className="lbl-title">Nombre secretario</p>
                        <label>{secretary.name}</label>
                    </div>
                    <div className="col-md-4 col-12">
                        <p className="lbl-title">Nombre usuario</p>
                        <label>{secretary.username}</label>
                    </div>
                    <div className="col-md-4 col-12">
                        <p className="lbl-title">Última sincronización</p>
                        <label>{secretary.last_sync}</label>
                    </div>

                </div>
                <div className="row separate">
                    <div className="col-md-4 col-12">
                        <p className="lbl-title">Dispositivo vinculado</p>
                        <label>{secretary.device_id}</label>
                    </div>
                </div>
            </div>
            <ModalDesactivar
                {...modalDesactivar}
                confirm={ConfirmModalActivate}
                handleClose={handleClose}
            />
        </div>

    </div>)
}

export default withRouter(DetailsApuntador);